<template>
  <div class="organizer-container">
    <h2 class="title">Terms of use</h2>
    <div class="contracts-container" v-if="form.authorizedPerson">
      <div class="contract-card">
        <div class="card-header">
          <img src="/assets/file.svg" alt="file icon" class="file-icon" />
          Contract Model 1
        </div>
        <div v-if="contract1Extended && contract1Url" class="contract-content">
          <div class="contract-text">
            <object type="application/pdf" :data="contract1Url" width="100%" height="100%">
              <span>cannot load pdf</span>
            </object>
          </div>
         </div>
        <div class="card-checkbox">
          <checkbox 
            v-if="!organizationSlug" 
            color="primary" 
            v-model="form.acceptedContract1" 
            :disabled="!contract1Extended"
          >
            <div>I have reviewed and accept the completed contract in order to finalize the registration.</div>
          </checkbox>
          <main-button 
            flat 
            :text="contract1Extended ? 'see less' : 'preview'" 
            @click="contract1Extended=!contract1Extended;"
          />
        </div>
      </div>
      <div class="contract-card">
        <div class="card-header">
          <img src="/assets/file.svg" alt="file icon" class="file-icon" />
          Contract Model 2
        </div>
        <div v-if="contract2Extended && contract2Url" class="contract-content">
          <div class="contract-text">
            <object type="application/pdf" :data="contract2Url" width="100%" height="100%">
              <span>cannot load pdf</span>
            </object>
          </div>
         </div>
        <div class="card-checkbox">
          <checkbox 
            v-if="!organizationSlug" 
            color="primary" 
            v-model="form.acceptedContract2" 
            :disabled="!contract2Extended || !contract1Url"
          >
            <div>I have reviewed and accept the completed contract in order to finalize the registration.</div>
          </checkbox>
          <main-button 
            flat 
            :text="contract2Extended ? 'see less' : 'preview'" 
            @click="contract2Extended=!contract2Extended"
          />
        </div>
      </div>
      <div class="custom-contract" v-if="!organizationSlug">
        For Custom Contract and Terms of Service, <a href="mailto:contact@core-event.co"> contact CoreEvent.</a>
      </div>
    </div>
    <div v-else>
      No contract templates available
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { GET_ORGANIZATION } from '../../graphql/organization.graphql.js'

export default {
  name: 'organization-terms-of-use-form',
  props: {
    vs: {
      type: Object,
      default: () => {},
    },
    initialValues: {
      type: Object,
      default: () => ({}),
    },
    organizationSlug: {
      type: String,
    },
  },
  data() {
    return {
      contract1Extended: false,
      contract2Extended: false,
      form: this.initialValues,
      contract1Url: null,
      contract2Url: null,
    }
  },
  async mounted() {
    if (this.organizationSlug) { 
      await this.getOrganizationInfo()
    } else { 
      await this.generateContractPdfs()
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
  methods: {
    async generateContractPdfs() {
      try {
        const contract_1 = await axios.post(`${process.env.VUE_APP_SERVER_URL}/files/organization/contract`, 
          { ...this.form, contract: 'contract_model1_template' }, 
          { responseType: 'blob' },
        )
        const contract_2 = await axios.post(`${process.env.VUE_APP_SERVER_URL}/files/organization/contract`, 
          { ...this.form, contract: 'contract_model2_template' }, 
          { responseType: 'blob' },
        )

        const blob1 = new Blob([contract_1.data], { type: 'application/pdf' })
        const blob2 = new Blob([contract_2.data], { type: 'application/pdf' })

        this.contract1Url = URL.createObjectURL(blob1)+ '#zoom=FitW'
        this.contract2Url = URL.createObjectURL(blob2)+ '#zoom=FitW'
      
      } catch (error) {
        console.error("Error generating PDF:", error)
      }
    },
    async getOrganizationInfo() {
      const { data } = await this.$apollo.query({
        query: GET_ORGANIZATION,
        variables: { organizationSlug: this.organizationSlug },
      })
      if (data && data.getOrganization.authorizedPerson) {
        this.form = data.getOrganization
        await this.generateContractPdfs()
      }
    }
  },
}
</script>

<style scoped>
.organizer-container {
  display: flex;
  flex-direction: column;
}
.title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.contracts-container {
  display: flex;
  flex-direction: column;
  row-gap: 2rem;
  align-self: stretch;
}
.contract-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 16px;
  border: 2px solid #D9D9D9;
  overflow: hidden;
  max-width: 870px;
}
.card-header {
  display: flex;
  padding: 24px;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  background: #F5F5F5;
  color: #666;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.72px;
}
.card-checkbox {
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  background: #FFF;
}
.contract-content {
  display: flex;
  flex: 1 0 0;
  padding: 16px 24px;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
}
.contract-text {
  color: #666;
  font-family: "Source Sans Pro";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  height: 250px;
  overflow-y: scroll;
  -ms-overflow-style: scrollbar;
  scrollbar-width: auto;
  padding-right: 24px;
  display: flex;
  gap: 28px;
  flex: 1 0 0;
}
.custom-contract {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding-left: 24px;
  color: #666;
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  gap: 5px;
}
</style>